module.exports = __webpack_public_path__ + "static/media/03_CALCINHA_ASA_DELTA_06.83a3ba65.jpg";